import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.slice.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

_pushScopeId("data-v-4b3cf9c7");

var _hoisted_1 = {
  class: "item-wrapper"
};
var _hoisted_2 = {
  class: "date-wrapper"
};

_popScopeId();

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_authorImg = _resolveComponent("authorImg");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_authorImg, {
    headImg: $props.item.headImg,
    nickName: $props.item.nickName,
    userId: $props.item.addUserId,
    userType: $props.item.isVip,
    source: $props.item.source,
    tags: $props.item.identificationDesc
  }, null, 8, ["headImg", "nickName", "userId", "userType", "source", "tags"]), _createElementVNode("div", _hoisted_2, _toDisplayString($props.item.addTime.slice(0, 16).replace("T", " ")), 1)]);
}